import { api } from '../../../../shared/services/api';
import Cookies from 'js-cookie';
import { AxiosError } from 'axios';
import { IResponseAjud } from '../../../../shared/services/types/response';

// Interfaces
export interface AjudArchiveData {
  data: {
    canceled_order: string;
    shipping_date: string;
    account_value_available: string;
    request_judge: string;
    court_order: string;
    cnpj_cpf_oj: string;
    lock_value: string;
  }[];
}

export interface UnlockUpdate {
  response_code: string;
  available_value_unlock: string;
  lock_remaining: string;
}
export interface ModalBlockProps {
  ajudValue: IResponseAjud | null;
  closeModal: (shouldReload?: boolean) => void;
  open: boolean;
}

export const moneyMask = (value: string): string => {
  value = value.replace(/\D/g, ''); // Remove tudo que não for número
  const numberValue = Number(value) / 100; // Converte para número decimal
  return numberValue.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// Função para buscar os dados do arquivo AJUD
export const fetchAjudArchiveData = async (
  court_order: string,
): Promise<AjudArchiveData | null> => {
  try {
    const token = Cookies.get('@token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    const response = await api.get(
      `/ajudArchive/getAll?status=DONE&type_record=03&court_order=${court_order}`,
      config,
    );

    return response.data;
  } catch (err) {
    if (err instanceof AxiosError) {
      console.error(
        'Erro ao buscar dados:',
        err.response?.data?.message || 'Erro de conexão',
      );
    } else {
      console.error('Erro inesperado:', err);
    }
    return null;
  }
};

// Função para atualizar desbloqueio
export const updateAjudUnlock = async (
  id: string,
  values: UnlockUpdate,
): Promise<{ success: boolean; message?: string }> => {
  try {
    const token = Cookies.get('@token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    await api.put(`/ajudArchive/updateUnlock/${id}`, values, config);
    return { success: true };
  } catch (err) {
    if (err instanceof AxiosError) {
      console.error(
        'Erro ao atualizar desbloqueio:',
        err.response?.data?.error || 'Erro de conexão',
      );
      return {
        success: false,
        message: err.response?.data?.error || 'Erro de conexão',
      };
    } else {
      console.error('Erro inesperado:', err);
      return { success: false, message: 'Erro inesperado' };
    }
  }
};
